import { MARKET_ADDRESS } from "@silo/config";
import { createChecksumAddressRecordOrThrow } from "./utils";

export const MainnetLegacyMarketAddress = createChecksumAddressRecordOrThrow(
  MARKET_ADDRESS.mainnetLegacy
);

export const MainnetLlamaMarketAddress = createChecksumAddressRecordOrThrow(
  MARKET_ADDRESS.mainnetLlama
);

export const MainnetGrandMarketAddress = createChecksumAddressRecordOrThrow(
  MARKET_ADDRESS.mainnetGrand
);

export const ArbitrumMarketAddress = createChecksumAddressRecordOrThrow(
  MARKET_ADDRESS.arbitrum
);

export const OptimismMarketAddress = createChecksumAddressRecordOrThrow(
  MARKET_ADDRESS.optimism
);

export const BaseMarketAddress = createChecksumAddressRecordOrThrow(
  MARKET_ADDRESS.base
);

export const LrtbaseMarketAddress = createChecksumAddressRecordOrThrow(
  MARKET_ADDRESS.lrtbase
);

export const LocalMarketAddress = createChecksumAddressRecordOrThrow(
  MARKET_ADDRESS.local
);

export const AnvilMarketAddress = createChecksumAddressRecordOrThrow(
  MARKET_ADDRESS.anvil
);
